var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as Sentry from '@sentry/browser';
import { ShowReportDialog } from './utils/ShowReportDialog';
/**
 * @description ErrorBoundary wraps the component to watch render errors
 * errorMessage - message to send to Sentry
 * contentWidth - width of replacing content
 * showReportDialog - set visible to bug-report button if it's true
 *
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { hasError: false, eventId: '' };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error) {
        Sentry.configureScope(function (scope) {
            return scope
                .setTransactionName("\u041E\u0448\u0438\u0431\u043A\u0430 \u0440\u0435\u043D\u0434\u0435\u0440\u0430")
                .setLevel('fatal')
                .setTag('error.type', 'render')
                .setContext('Context', { error: error });
        });
        Sentry.captureException(error);
        var id = Sentry.captureMessage(this.props.errorMessage);
        this.setState({
            eventId: id,
        });
    };
    ErrorBoundary.prototype.render = function () {
        var _a = this.props, showAlertReportBtn = _a.showAlertReportBtn, contentWidth = _a.contentWidth, children = _a.children, fallback = _a.fallback, fallbackContainerStyle = _a.fallbackContainerStyle;
        var _b = this.state, hasError = _b.hasError, eventId = _b.eventId;
        if (hasError) {
            return (_jsxs("div", __assign({ className: 'fallback-container', style: fallbackContainerStyle ? fallbackContainerStyle : {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '20px',
                    padding: '12px',
                    textAlign: 'center',
                    width: contentWidth !== null && contentWidth !== void 0 ? contentWidth : '100%',
                    height: '100%',
                } }, { children: [fallback ? fallback : _jsxs(_Fragment, { children: [_jsx("h1", { children: "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430:" }), _jsx("h2", { children: "\u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438\u043B\u0438 \u0432\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u043F\u043E\u0437\u0436\u0435" })] }), showAlertReportBtn && (_jsx("button", __assign({ className: 'error-handler-report-btn', onClick: function () { return ShowReportDialog(eventId); } }, { children: "\u0417\u0430\u044F\u0432\u0438\u0442\u044C \u043E\u0431 \u043E\u0448\u0438\u0431\u043A\u0435" })))] })));
        }
        return _jsx(_Fragment, { children: children });
    };
    return ErrorBoundary;
}(React.Component));
export default ErrorBoundary;
